<script lang="ts">
  import { createQueries } from '@tanstack/svelte-query';

  import ProductCard from '$components/product-card/product-card.svelte';
  import Skeleton from '$components/ui/skeleton.svelte';

  import { shopify } from '$lib/shopify';
  import { isCmsStory } from '$lib/utils/cms';

  import type { FourProductsStoryblok } from '$types/bloks';
  import { lang } from '$lib/lang';
  import type { LanguageCode } from '$gql/storefront/schemas';
  import { optimalUSCountry, parseCountryAsCode } from '$lib/country';

  export let block: FourProductsStoryblok;

  const handles = block.products.reduce<string[]>((acc, product) => {
    if (isCmsStory(product)) {
      acc.push(product.slug);
    }
    return acc;
  }, []);

  const queries = createQueries(
    handles.map((handle) => ({
      staleTime: 5 * 60 * 1000,
      queryKey: ['productCard', handle],
      queryFn: async () => {
        return await $shopify.getProductCard({
          handle,
          lang: $lang.toUpperCase() as LanguageCode,
          country: parseCountryAsCode($optimalUSCountry)
        });
      }
    }))
  );

  $: arr = $queries.map((q) => q.data?.product);
  $: products = arr.filter(Boolean) as NonNullable<(typeof arr)[number]>[];
  $: loading = $queries.some((q) => q.isLoading);
</script>

{#if products.length > 0 || loading}
  <section class="p-2 lg:p-8">
    <div class="container mx-auto lg:gap-4 lg:grid-cols-4 grid grid-cols-2 gap-2">
      {#if products.length > 0 && !loading}
        {#each products as product ('four-products' + product.id)}
          {#if product}
            <ProductCard {product} />
          {/if}
        {/each}
      {:else}
        {#each Array(4) as _}
          <Skeleton class="rounded-md aspect-[183/304] lg:aspect-[332/480]" />
        {/each}
      {/if}
    </div>
  </section>
{/if}
